import React, { useCallback, useContext, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Typography } from "@mui/material";
import { Card, FormCard, SpinnerLoader } from "../components";
import { ButtonsStep } from "../components/buttons";
import PaymentService from "../services/PaymentService";
import SessionService from "../services/SessionService";
import {
  emailDetectedSelector,
  userDummySelector,
  userExistSelector,
} from "../state/selectors/sessionSelectors";
import LoadingContext from "../context/LoadingProvider";
import { setUserSession } from "../state/actions";

const PaymentNew = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userDummy = useSelector(userDummySelector);
  const emailDetected = useSelector(emailDetectedSelector);
  const userExist = useSelector(userExistSelector);

  const { setLoadingValue } = useContext(LoadingContext);
  const { loading } = useSelector((state: any) => state.variables);
  const [invalidState, setInvalidState] = useState(true);
  const [formStep, setFormStep] = useState(0);
  const [proveedor, setProveedor] = useState("CARD");
  const [values, setValues] = useState({
    cardType: "",
    numberCard: "",
    completeCardName: "",
    expirationDate: "",
    securityCode: "",
    resultEvaluate: "",
    cardIdentification: 1,
    identificationNumber: "",
  });

  const returnUrl = location.state?.from || "/payment/list";

  const createPayment = () => {
    setLoadingValue(true);
    createNewPaymentCard();
  };

  const createNewPaymentCard = useCallback(async () => {
    setLoadingValue(true);
    PaymentService.createPaymentCard({
      login: emailDetected || userDummy.login,
      name: values.completeCardName,
      card_number: values.numberCard,
      security_code: values.securityCode,
      expiration_month: values.expirationDate.slice(0, 2),
      expiration_year: "20" + values.expirationDate.slice(2, 4),
      card_type: values.cardType,
      card_identification: values.cardIdentification.toString(),
      state: "disabled",
    })
      .then((res) => {
        if (!res?.result) {
          toast("No se añadió la tarjeta...");
        } else if (res?.result?.status && res?.result?.status > 201) {
          toast(res?.result?.message);
        } else {
          toast("Medio de pago cargado");
          navigate(returnUrl);
        }
      })
      .finally(() => setLoadingValue(false));
  }, [
    values,
    emailDetected,
    navigate,
    setLoadingValue,
    userDummy.login,
    returnUrl,
  ]);

  const nextStep = useCallback(() => {
    setFormStep(formStep + 1);
  }, [formStep]);

  const previousStep = useCallback(() => {
    setFormStep(formStep - 1);
  }, [formStep]);

  const handleChange = (prop: string) => (event: any) => {
    setValues((prev) => ({ ...prev, [prop]: event.target.value }));
  };

  return loading ? (
    <SpinnerLoader />
  ) : (
    <>
      <pre>{}</pre>
      <Typography component="h1" variant="subtitle1">
        Ingrese{" "}
        {formStep === 0
          ? "Tipo y Número de tarjeta"
          : formStep === 1
          ? "el Titular"
          : formStep === 2
          ? "el Vencimiento y Código de Seguridad"
          : "el Número de Documento"}
      </Typography>

      <Card values={values} proveedor={proveedor} />

      <FormCard
        {...{ values, formStep, handleChange, setInvalidState, setProveedor }}
      />
      <div>
        <ButtonsStep
          nextStep={nextStep}
          previousStep={previousStep}
          formStep={formStep}
          invalidState={invalidState}
          createPayment={createPayment}
          returnUrl={returnUrl}
        />
      </div>
    </>
  );
};

export default PaymentNew;
